module.exports = __webpack_public_path__ + "img/pen-blue.bd9ec53b.svg";